export default __webpack_public_path__ + "static/bg-pattern-939de03cf7c1cc0567bfb94959bd31f0.png";